import { render, staticRenderFns } from "./portraitComparison.vue?vue&type=template&id=a8477532&scoped=true&"
import script from "./portraitComparison.vue?vue&type=script&lang=js&"
export * from "./portraitComparison.vue?vue&type=script&lang=js&"
import style0 from "./portraitComparison.vue?vue&type=style&index=0&id=a8477532&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8477532",
  null
  
)

export default component.exports